exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, "._3hmL8leXzyRcEOG8QOMPvy {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n", "",{"version":3,"sources":["Main.pcss"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB","file":"Main.pcss","sourcesContent":[".wrapper {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n"]}]);

// Exports
exports.locals = {
	"wrapper": "_3hmL8leXzyRcEOG8QOMPvy"
};